'use strict';

var isios = require('./is_ios');

module.exports = function () {
  var ua = String(window.navigator.userAgent).toLowerCase();
  var isAndroid = !isios() && ua.indexOf('android') > 1;
  var isChrome = !!ua.match(/(?:Chrome|CriOS)\/([\d\.]+)/i);
  return isAndroid && isChrome;
};